module.exports = __webpack_public_path__ + "img/charity_1.19b4a638.png";